import React, { Component } from "react";
import ReactDOM from "react-dom";

class CamSwitch extends Component{
  constructor() {
    super();
    this.pinToggle = this.pinToggle.bind(this);
    this.showToggle = this.showToggle.bind(this);
    this.onSwitchOver = this.onSwitchOver.bind(this);
    this.onSwitchOut = this.onSwitchOut.bind(this);
    this.state = {
      selectingStream: false,
      hovering: false,
    }

  }
  pinToggle() {
    if(this.isPinned()){
      this.props.removeCam(this.props.camName, true);
    }
    else{
      this.props.addCam(this.props.camName, true);
    }
  }
  showToggle() {
    if(!this.isVisible()){
      this.props.addCam(this.props.camName, false);
    }
    else{
       this.props.removeCam(this.props.camName, true);
    }
  }
  isPinned() {
    const pane = this.props.getCamPane(this.props.camName);
    if (pane === undefined){
      return false;
    }
    return pane.pinned ? true: false;
  }
  isVisible() {
    const pane = this.props.getCamPane(this.props.camName);
    if (pane === undefined){
      return false;
    }
    return true;
  }
  onSwitchOver(){
    this.props.setHightLightPane(this.props.camName, true);
    this.setState({hovering: true});
  }
  onSwitchOut(){
    this.props.setHightLightPane(this.props.camName, false);
    this.setState({hovering: false});
  }
  render() {
    const isPinned = this.isPinned();
    const isVisible = this.isVisible();
    let buttons = null;
    if (this.props.showCamSwitches === true){
      buttons = (
        <div
          onMouseOver={this.onSwitchOver}
          onMouseOut={this.onSwitchOut}
          className="flex-row button-switch-row">
            <LockButton
              onClick={this.pinToggle}
              camName={this.props.camName}
              camNameDetails={this.props.camNameDetails}
              checked={isPinned}
            />
            <ShowButton
              onClick={this.showToggle}
              camName={this.props.camName}
              camNameDetails={this.props.camNameDetails}
              hovering={this.state.hovering}
              checked={isVisible}
            />
        </div>
       );
    }
    return (buttons);
  }

}

class ShowButton extends Component {
  constructor() {
      super();
      this.showConfig = this.showConfig.bind(this);
      this.hideConfig = this.hideConfig.bind(this);
      this.state = {
        showingStreamButtons: false
      }
  }
  showConfig(event){
    event.stopPropagation();
    this.setState({showingStreamButtons:true});
  }
  hideConfig(event){
    event.stopPropagation();
    this.setState({showingStreamButtons:false});
  }
  render(){
    const props = this.props;
    const classType = props.checked ? "pressed":"free";

    let className = " button-container btn-camswitch btn-camswitch-select "
    className += "btn-camswitch-select-" + classType + " ";
    if (props.checked === true){
      className += " btn-camswitch-select-show-border ";
    }
    else{
      className += " btn-camswitch-select-show-border ";
    }
    // let cam_name = props.camName.split(".").slice(0,-1).join(".");
    let firstRowClassName = "btn-switch-cam-name-facility";
    if (props.checked === false){
      firstRowClassName += ` btn-facility-color-${(props.camNameDetails.facilityIndex % 4) + 1}`;
    }
    let firstRow = (
      <div className={firstRowClassName}>
        {props.camNameDetails.facility}
      </div> 
    );

    let groupClass = "btn-switch-cam-name-group";
    let groupColorIndex = (props.camNameDetails.facilityGroupIndex % 6) + 1;
    if (props.checked === false){
      groupClass += ` btn-group-color-${groupColorIndex}`;
    }

    let numberClass = "btn-switch-cam-name-number";
    if (props.checked === false){
      numberClass += ` btn-group-color-${groupColorIndex}`;
    }


    let secondRow = undefined;
    if (props.camNameDetails.group !== undefined){
      let items = [<div key="cam-name-group" className={groupClass}>{props.camNameDetails.group}</div>];
      if (props.camNameDetails.number !== undefined){
        items.push(<div key="cam-name-number" className={numberClass}>{props.camNameDetails.number}</div>)
      }
      secondRow = <div className="flex-row">{items}</div>
    }
    const button = (
      <div className="flex-row flex-1" onClick={props.onClick}>
        <button className={className + "flex-1 btn-cam-show-width flex-column justify-content-center"}> 
          {firstRow}
          {secondRow}
        </button>
      </div>
    );
    return(button);
  }
}

function LockButton(props){
  const classType = props.checked ? "pressed":"free";
  const button = (
    <button
      className={"button-container btn-camswitch btn-lock-" + classType + " btn-lock"}
      onClick={props.onClick}>{props.camNameDetails.index}&#x275A;
    </button>
    );
  return(button);
}

function parseCamNameParts(camName){
  let nameParts = camName.split("-");
  let facility = nameParts[0];
  let group = undefined;
  let number = undefined;
  if (nameParts.length > 1){
    facility = nameParts[0];
    group = nameParts.slice(1).join("-");
    let numericSufix = group.split(/[0-9]*$/);
    if(numericSufix.length == 2){
      let numericSufixParts =  group.split(numericSufix[0]);
      group = numericSufix[0];
      number = numericSufixParts[1];
      
    }

  }
  return {facility, group, number}
}

function CamSwitchBoard(props){
  let facilities = new Set();
  let facilityGroups = new Set();
  for( const camName of props.cameras){
    let {facility, group} = parseCamNameParts(camName);
    facilities.add(facility);
    if(group !== undefined){
      facilityGroups.add([facility, group].join("::"));
    }
  }
  facilities = Array.from(facilities);
  facilityGroups = Array.from(facilityGroups);
  // console.log(facilities, facilityGroups);

  const switches = props.cameras.map((camName, index) => {
      let {facility, group, number} = parseCamNameParts(camName);
      let facilityIndex = facilities.indexOf(facility);
      let facilityGroupIndex = facilityGroups.indexOf([facility, group].join("::"));
      let camNameDetails = {facility, group, number, facilityIndex, facilityGroupIndex, index:index +1};


      return <CamSwitch
        key={camName}
        showCamSwitches={props.showCamSwitches}
        camName={camName}
        camNameDetails={camNameDetails}
        getCamPane={props.getCamPane}
        addCam={props.addCam}
        removeCam={props.removeCam}
        setHightLightPane={props.setHightLightPane}
      />
    });
  return (
    <div className="switch-board">
      <div className="flex-grow-1"/>
      <div className="flex-column align-items-flex-end">{switches}</div>
      <div className="flex-grow-2"/>
      <div className="flex-grow-2"/>
    </div>
  );
}

export default CamSwitchBoard;